import { render, staticRenderFns } from "./surveyMUIC.vue?vue&type=template&id=66381e32&scoped=true&"
import script from "./surveyMUIC.vue?vue&type=script&lang=js&"
export * from "./surveyMUIC.vue?vue&type=script&lang=js&"
import style0 from "./surveyMUIC.vue?vue&type=style&index=0&lang=css&"
import style1 from "./surveyMUIC.vue?vue&type=style&index=1&id=66381e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66381e32",
  null
  
)

export default component.exports